import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "activity-list" }

import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';

import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  useCreateModal,
  createDialog,
  XrkMessage
} from 'xrk-components';
import ActivityPerson from './activity-person.vue';
import BaseAuditStatusSelect from '@/components/biz/biz-status-select/index';
import ActivtyDetail from './activty-detail.vue';
import ActivityUploadFile from './activity-upload-file.vue';
import {
  activityList,
  activityDetail,
  createactivity,
  updateActivityName,
  activitySubmit
} from '../data-source/apis';
import { timeSearch, activityNameSearch } from '../fields/searchs';
import { formatter } from '@/utils';
import { platformAuditStatusCol } from '../fields/columns';
import BaseInsert from './base-insert.vue';
import OperationRecord from '../components/operation-record.vue';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import appStore from '@/store';
import { useRouter, useRoute } from 'vue-router';

type Item = { label: string; value: number; num: number };


export default /*#__PURE__*/_defineComponent({
  __name: 'activity-list',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
const xrkTableRef = ref<XrkTableRef>();

const projectId = computed<number>(() => {
  return projectInfo.value.id;
});

//协定服务上传来源1ASP上传2C端上传3双方共同上传
const agreementServiceUploadType = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadType;
});

//协定服务上传方式1以活动方式上传2以人为维度上传
const agreementServiceUploadMode = computed<number>(() => {
  return store.baseData.reqsInfo.agreementServiceUploadMode;
});
const isEntry = [
  +agreementServiceUploadMode.value,
  +agreementServiceUploadType.value
].join(',');
// '1,3': '活动形式-双方共同上传',
// '1,1': '活动形式-服务商上传',
// '2,2': '人为维度-终端上传',
// '2,1': '人为维度-服务商上传',

const statusMap = ref<Item[]>(null); // 审核状态+条数

// const auditStatusSelectDefaultValue = ref(route.query.activityName ? null : 0);
const auditStatusSelectDefaultValue = ref(null);

const auditStatusSelectKey = ref(0);

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
const isAsp = computed(() => defaultUserFnCode.value === 2);
const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};

const onChangeAuditStatus = (val: string[]) => {
  const _val = val.filter(item => item !== null);
  xrkTableRef.value?.setSearchValue(
    'platformAuditStatus',
    _val.length ? _val : null
  );
  onRefreshTabel();
};

const baseInsertRef = ref();
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      // 清除路由上的查询参数
      if (route.query.activityName) {
        router.replace({
          query: { ...route.query, activityName: null }
        });
      }
    }
  },
  searchColumns: [
    timeSearch,
    { ...activityNameSearch, defaultValue: route.query.activityName }
  ],
  otherComponents: [
    isAsp.value && {
      render() {
        return (
          <>
            <BaseButton
              type="primary2"
              onClick={() => {
                createDialog({
                  width: 400,
                  title: '创建活动',
                  showClose: true,
                  contentRender: () => {
                    return (
                      <>
                        <div style="padding:20px">
                          <BaseInsert
                            labelPosition={'left'}
                            ruleValidator={(
                              rule: any,
                              value: any,
                              callback: any
                            ) => {
                              if (value === '') {
                                return callback(new Error('活动名称不能为空'));
                              } else {
                                callback();
                              }
                            }}
                            label={'活动名称'}
                            placeholder={'请输入最多50个字'}
                            maxlength={50}
                            type="text"
                            ref={baseInsertRef}
                          ></BaseInsert>
                        </div>
                      </>
                    );
                  },
                  beforeConfirm: async done => {
                    const { data } = await baseInsertRef.value.getFormData();
                    await createactivity({
                      projectId: projectId.value,
                      activityName: data
                    });
                    onRefreshTabel();
                    done();
                  }
                });
              }}
            >
              添加活动
            </BaseButton>
          </>
        );
      }
    }
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '活动名称',
      prop: 'taskName',
      render: ({ cellValue, row }) => {
        return (
          <>
            <span>{cellValue}</span>
            {isAsp.value && (
              <BaseButton
                disabled={[1, 2].includes(row.platformAuditStatus)}
                onClick={() => {
                  createDialog({
                    width: 400,
                    title: '修改活动名称',
                    showClose: true,
                    contentRender: () => {
                      return (
                        <>
                          <div style="padding:20px">
                            <BaseInsert
                              labelPosition={'left'}
                              ruleValidator={(
                                rule: any,
                                value: any,
                                callback: any
                              ) => {
                                if (value === '') {
                                  return callback(
                                    new Error('活动名称不能为空')
                                  );
                                } else {
                                  callback();
                                }
                              }}
                              label={'活动名称'}
                              placeholder={'请输入最多50个字'}
                              maxlength={50}
                              type="text"
                              ref={baseInsertRef}
                              defaultValue={cellValue}
                            ></BaseInsert>
                          </div>
                        </>
                      );
                    },
                    beforeConfirm: async done => {
                      const { data } = await baseInsertRef.value.getFormData();
                      await updateActivityName({
                        activityId: row.id,
                        activityName: data
                      });
                      onRefreshTabel();
                      done();
                    }
                  });
                }}
                type="text"
              >
                修改
              </BaseButton>
            )}
          </>
        );
      }
    }),
    useTableColumn({
      label: '活动参与人',
      prop: 'peopleNum',
      render: ({ cellValue, row }) => {
        return (
          <>
            <BaseButton
              onClick={() => {
                createDialog({
                  width: 950,
                  title: '活动参与人员',
                  showClose: true,
                  contentRender: () => {
                    return (
                      <div style="padding: 20px;">
                        <ActivityPerson
                          disabled={[1, 2].includes(row.platformAuditStatus)}
                          submitStatus={row.submitStatus}
                          activityId={row.id}
                          projectId={projectId.value}
                        ></ActivityPerson>
                      </div>
                    );
                  },
                  beforeConfirm: async done => {
                    onRefreshTabel();
                    done();
                  },
                  beforeClose(done) {
                    onRefreshTabel();
                    done();
                  },
                  beforeCancel(done) {
                    onRefreshTabel();
                    done();
                  }
                });
              }}
              type="text"
            >
              {cellValue}
            </BaseButton>
          </>
        );
      }
    }),
    isEntry === '1,3' &&
      useTableColumn({
        label: '参与人提交任务数',
        prop: 'peopleSubmitNum',
        render({ cellValue, row }) {
          return (
            <>
              <BaseButton
                disabled={!cellValue}
                type="text"
                onClick={() => {
                  router.replace({
                    path: '/main/asp/task-mgmt-list/list',
                    query: {
                      activityName: row.taskName,
                      pageName: 'taskRecord'
                    }
                  });
                }}
              >
                {cellValue === null ? '-' : cellValue}
              </BaseButton>
            </>
          );
        }
      }),
    useTableColumn({
      label: '提交时间',
      prop: 'submitAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '任务附件',
      prop: 'folderName',
      render: ({ cellValue, row }) => {
        return (
          <>
            {cellValue ? '已上传' : '未上传'}
            {isAsp.value && (
              <BaseButton
                disabled={[1, 2].includes(row.platformAuditStatus)}
                onClick={() => {
                  const activityUploadFileModal = useCreateModal(
                    ActivityUploadFile,
                    {
                      activityId: row.id,
                      onSuccess() {
                        XrkMessage.success('操作成功');
                        activityUploadFileModal.remove();
                        onRefreshTabel();
                      }
                    }
                  );
                }}
                type="text"
              >
                编辑
              </BaseButton>
            )}
          </>
        );
      }
    }),
    useTableColumn({
      label: '提交状态',
      prop: 'submitStatus',
      formatter: ({ cellValue }) => (cellValue ? '已提交' : '未提交')
    }),
    platformAuditStatusCol,
    useTableColumn({
      align: 'center',
      fixed: 'right',
      label: '操作',
      width: 210,
      render({ row }) {
        const subDisabled = () => {
          return (
            (row.submitStatus !== 0 &&
              [1, 2].includes(row.platformAuditStatus)) ||
            !row.folderName ||
            +row.peopleNum === 0
          );
        };
        return (
          <>
            <div>
              <BaseButton
                onClick={async () => {
                  const { data } = await activityDetail({
                    activityId: row.id
                  });
                  useCreateModal(ActivtyDetail, {
                    detailInfo: data
                  });
                }}
                type="text"
              >
                查看
              </BaseButton>
              {isAsp.value && (
                <>
                  <BaseButton
                    disabled={subDisabled()}
                    onClick={async () => {
                      await activitySubmit({ activityId: row.id });
                      XrkMessage.success('提交成功');
                      onRefreshTabel();
                    }}
                    type="text"
                  >
                    提交
                  </BaseButton>
                  <BaseButton
                    onClick={async () => {
                      createDialog({
                        width: 850,
                        title: '操作记录',
                        showClose: true,
                        contentRender: () => {
                          return (
                            <div style="padding: 20px;">
                              <OperationRecord
                                taskRecordId={row.id}
                              ></OperationRecord>
                            </div>
                          );
                        },
                        beforeConfirm: async done => {
                          done();
                        }
                      });
                    }}
                    type="text"
                  >
                    操作记录
                  </BaseButton>
                </>
              )}
            </div>
          </>
        );
      }
    })
  ].filter(Boolean),
  baseConfig: {}
});

const getListAjax = async params => {
  const [submitAtStart, submitAtEnd] = params?.editStatusAt || ['', ''];

  // 上方筛选框默认值
  const platformAuditStatus =
    params.platformAuditStatus === undefined
      ? [auditStatusSelectDefaultValue.value]
      : params.platformAuditStatus;

  const { data } = await activityList({
    ...params,
    submitAtStart,
    submitAtEnd,
    platformAuditStatus:
      platformAuditStatus?.length === 1 && platformAuditStatus[0] === null
        ? null
        : platformAuditStatus,
    projectId: projectId.value
  });

  // 状态筛选暂时先不要了（协定服务活动线上没多少数据） -薛利
  // statusMap.value = [
  //   {
  //     label: '全部',
  //     value: null,
  //     num:
  //       Object.values(data.map as number[]).reduce((acc, cur) => acc + cur, 0) -
  //       (data.map[3] || 0)
  //   },
  //   {
  //     label: '服务商待提交',
  //     value: 0,
  //     num: data.map[0] || 0
  //   },
  //   {
  //     label: '待平台审核',
  //     value: 1,
  //     num: data.map[1] || 0
  //   },
  //   {
  //     label: '审核通过',
  //     value: 2,
  //     num: data.map[2] || 0
  //   },
  //   {
  //     label: '审核未通过',
  //     value: 3,
  //     num: data.map[3] || 0
  //   }
  // ];
  statusMap.value = [];
  return { data: data.pagerPKT };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_unref(BaseAuditStatusSelect), {
      onChangeStatus: onChangeAuditStatus,
      key: auditStatusSelectKey.value,
      statusMap: statusMap.value,
      defaultValue: auditStatusSelectDefaultValue.value
    }, null, 8, ["statusMap", "defaultValue"])),
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})